
































import { Component, Vue } from 'vue-property-decorator'

import { Action, State } from 'vuex-class'

import { ConfirmLeaveModal, InvoiceFiltersForm } from '@/components'

import { MobileLayout } from '@/layouts/components'

import {
  ModalState,
  InvoiceFilters,
  InvoicePageQuery,
  InvoiceStatus
} from '@/models'

import { RootState } from '@/store/state'

import { isSetsEqual, normalizeDate } from '@/utils'

@Component({
  components: {
    ConfirmLeaveModal,
    MobileLayout,
    InvoiceFiltersForm
  }
})
export default class ChangeInvoiceFilters extends Vue {
  confirmLeaveState = new ModalState()

  defaultFilters: InvoiceFilters = {
    status: [
      InvoiceStatus.OPEN,
      InvoiceStatus.CLOSING
    ]
  }

  data: InvoiceFilters | null = null
  isValid = false

  get hasChanges () {
    return this.data !== null && !this.compareFilters(this.data, this.query)
  }

  get isClear () {
    return this.data !== null && this.compareFilters(this.data, this.defaultFilters)
  }

  @State((state: RootState) => state.ordering.invoices.query)
  readonly query!: InvoicePageQuery

  @Action('ordering/changeInvoiceFilter')
  changeFilters!: (params: { filters: InvoiceFilters; isDefaultFilters: boolean }) => Promise<void>

  @Action('ordering/loadInvoicePage')
  loadInvoicePage!: () => Promise<void>

  async reload () {
    try {
      await this.loadInvoicePage()
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async clearFilters () {
    await this.changeFilters({
      filters: this.defaultFilters,
      isDefaultFilters: true
    })

    this.goBack()
  }

  async handleSubmit () {
    if (this.data === null || !this.hasChanges || !this.isValid) {
      return
    }

    await this.changeFilters({
      filters: {
        from: normalizeDate(this.data.from ?? '') ?? undefined,
        until: normalizeDate(this.data.until ?? '') ?? undefined,
        status: this.data.status,
        paymentMethods: this.data.paymentMethods
      },
      isDefaultFilters: this.isClear
    })
    await this.reload()
    this.goBack()
  }

  handleGoBack () {
    if (this.hasChanges) {
      this.confirmLeaveState.isActive = true
    } else {
      this.goBack()
    }
  }

  goBack () {
    this.$router.back()
  }

  compareFilters (a: InvoiceFilters, b: InvoiceFilters): boolean {
    return (
      (a.from === b.from || (!a.from && !b.from)) &&
      (a.until === b.until || (!a.until && !b.until)) &&
      isSetsEqual(new Set(a.status), new Set(b.status)) &&
      isSetsEqual(new Set(a.paymentMethods), new Set(b.paymentMethods))
    )
  }
}
